import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {NavItem, NavItemsType} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-sidebar-item-link',
  templateUrl: 'sidebar-item-link.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['sidebar-item-link.component.scss']
})
export class SidebarItemLinkComponent implements OnInit, OnChanges {

  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Input() selectionMode: 'border' | 'subMenu' = 'border';
  public linkType: 'COLLAPSED_SUB_MENU' | 'COLLAPSED_LINK' | 'SUB_MENU' | 'LINK';
  public classCss: string = '';
  public T = NavItemsType;
  public isEnabled = true;
  public showLabelTooltip: boolean;

  constructor(private permissionService: NgxPermissionsService) {
  }

  isSubMenu() {
    return this.selectionMode === 'subMenu';
  }

  ngOnInit(): void {
    this.calcPermission();
    this.calcMode();
    this.classCss = this.item?.classCss ? this.item?.classCss?.join(' ') : '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.linkType = null;
    this.calcPermission();
    this.calcMode();

    if (changes.collapsed) {
      this.showLabelTooltip = changes.collapsed.currentValue && this.item.tooltipEnabled;
    }
  }

  isLeafItemLink() {
    if (this.item.classCss) {
      return this.item.classCss.includes('sidebar-link--leaf');
    }
    return false;
  }

  private calcMode() {
    switch (true) {
      case !this.isSubMenu() && this.collapsed:
        this.linkType = 'COLLAPSED_LINK';
        break;
      case this.isSubMenu() && this.collapsed:
        this.linkType = 'COLLAPSED_SUB_MENU';
        break;
      case this.isSubMenu() && !this.collapsed:
        this.linkType = 'SUB_MENU';
        break;
      case !this.isSubMenu() && !this.collapsed:
        this.linkType = 'LINK';
        break;
    }
  }

  private calcPermission() {
    this.isEnabled = true;
    this.item.permissEnabled.forEach(p => {
      this.isEnabled = this.isEnabled && !!this.permissionService.getPermission(p);
    })
  }
}
